import { produce } from 'immer';
import { StateCreator } from 'zustand';

import { useConfigStore } from '../config.store';
import { IViewerStore } from './viewer.store';
import { Status, Theme } from './viewer.types';

export interface UiState {
  status: Status;
  isTranslationLoaded: boolean;
  theme: Theme;
}

export interface UiActions {
  setIsTranslationLoaded: (loaded: boolean) => void;
  setStatus: (status: Status) => void;
  setTheme: (theme: Theme) => void;
}

export type UiSlice = UiState & UiActions;

const getDefaultTheme = (): Theme => {
  const config = useConfigStore.getState();
  const defaultTheme = config.feature?.defaultTheme;

  return defaultTheme === 'light' ? Theme.Light : Theme.Dark;
};

export const createUiSlice: StateCreator<IViewerStore, [], [], UiSlice> = (set) => ({
  status: Status.Loading,
  isTranslationLoaded: false,
  theme: getDefaultTheme(),
  setIsTranslationLoaded: (loaded) =>
    set(
      produce((draft) => {
        draft.isTranslationLoaded = loaded;
      })
    ),
  setStatus: (status: Status) =>
    set(
      produce((draft) => {
        draft.status = status;
      })
    ),
  setTheme: (theme: Theme) =>
    set(
      produce((draft) => {
        draft.theme = theme;
      })
    ),
});
